import configureStore from 'store/configureStore';
import { history } from 'store/configureStore';

export { history };
export default configureStore;
